import React from 'react';
import { LockIcon, LockOpenIcon } from 'lucide-react';
import { usePortal } from '../../contexts/PortalContext';
import { pricingStatuses } from '../../data/pricingStatuses';
import { useTokens } from '../../hooks/useTokens';
export function PricingStatusBadge() {
  const {
    pricingStatus
  } = usePortal();
  const {
    fill
  } = useTokens();
  const s = pricingStatuses[pricingStatus];
  const cls = s.tone === 'positive' ? 'bg-positive-50 text-positive-700' : s.tone === 'pending' ? 'bg-caution-50 text-caution-700' : 'bg-ink-100 text-ink-700';
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${cls}`} data-id="element-499" data-mp="11np5luy07uzk">
      {pricingStatus === 'locked' ? <LockIcon className="h-3 w-3" aria-hidden data-id="element-500" data-mp="1bejvraedfeqa" /> : <LockOpenIcon className="h-3 w-3" aria-hidden data-id="element-501" data-mp="1bhftoyq7y3eq" />}
      {fill(s.label)}
    </span>;
}
export function PricingStatusNote() {
  const {
    pricingStatus
  } = usePortal();
  const {
    fill
  } = useTokens();
  return <p className="text-sm leading-relaxed text-ink-500" data-id="element-502" data-mp="17pyqc5lt6db1">{fill(pricingStatuses[pricingStatus].detail)}</p>;
}